import { render, staticRenderFns } from "./DutyContent.vue?vue&type=template&id=5ce36b8d&scoped=true"
import script from "./DutyContent.vue?vue&type=script&lang=js"
export * from "./DutyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce36b8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce36b8d')) {
      api.createRecord('5ce36b8d', component.options)
    } else {
      api.reload('5ce36b8d', component.options)
    }
    module.hot.accept("./DutyContent.vue?vue&type=template&id=5ce36b8d&scoped=true", function () {
      api.rerender('5ce36b8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/DutyContent.vue"
export default component.exports